import {
    CREATE_PRINTING_DC_DETAILS_FAILURE,
    CREATE_PRINTING_DC_DETAILS_REQUEST,
    CREATE_PRINTING_DC_DETAILS_SUCCESS,
    CREATE_USER_FORM_PRINTING_DC_DETAILS,
    DELETE_PRINTING_DC_DETAILS_FAILURE,
    DELETE_PRINTING_DC_DETAILS_REQUEST,
    DELETE_PRINTING_DC_DETAILS_SUCCESS,
    FETCH_SINGLE_PRINTING_DC_DETAILS_FAILURE,
    FETCH_SINGLE_PRINTING_DC_DETAILS_REQUEST,
    FETCH_SINGLE_PRINTING_DC_DETAILS_SUCCESS,
    FETCH_PRINTING_DC_DETAILS_FAILURE,
    FETCH_PRINTING_DC_DETAILS_REQUEST,
    FETCH_PRINTING_DC_DETAILS_SUCCESS,
    PRINTING_DC_DETAILS_USERFORM_RESET,
    UPDATE_PRINTING_DC_DETAILS_FAILURE,
    UPDATE_PRINTING_DC_DETAILS_REQUEST,
    UPDATE_PRINTING_DC_DETAILS_SUCCESS,
    FETCH_PRINTING_DC_DETAILS_BY_ID_REQUEST,
    FETCH_PRINTING_DC_DETAILS_BY_ID_SUCCESS,
    FETCH_PRINTING_DC_DETAILS_DC_NO_REQUEST,
    FETCH_PRINTING_DC_DETAILS_DC_NO_SUCCESS,
    FETCH_PRINTING_DC_DETAILS_DC_NO_FAILURE,
    FETCH_GRN_NO_BY_PRINTING_DC_NO_REQUEST,
    FETCH_GRN_NO_BY_PRINTING_DC_NO_SUCCESS,
    FETCH_GRN_NO_BY_PRINTING_DC_NO_FAILURE,
    FETCH_PRINTING_DC_DETAILS_PROGRAM_REQUEST,
    FETCH_PRINTING_DC_DETAILS_PROGRAM_SUCCESS,
    FETCH_PRINTING_DC_DETAILS_PROGRAM_FAILURE,
    FETCH_PRINTING_DC_PREVIOUS_LIST_REQUEST,
    FETCH_PRINTING_DC_PREVIOUS_LIST_SUCCESS,
    FETCH_PRINTING_DC_PREVIOUS_LIST_FAILURE,
    CREATE_USER_FORM_PRINTING_PART_DC_EDIT_QTY,
    RESET_PRINTING_PART_DC_EDIT_QTY_V2,
    RESET_PRINTING_PART_DC_SECOND_GRIG_EDIT_QTY_V2,
    CREATE_USER_FORM_PRINTING_PART_DC_SECOND_GRID_EDIT_QTY,
    FETCH_PRINTING_PART_DC_DETAILS_FIRST_GRID_REQUEST,
    FETCH_PRINTING_PART_DC_DETAILS_FIRST_GRID_SUCCESS,
    FETCH_PRINTING_PART_DC_DETAILS_FIRST_GRID_FAILURE,
    FETCH_PRINTING_PART_DC_DETAILS_SECOND_GRID_FAILURE,
    FETCH_PRINTING_PART_DC_DETAILS_SECOND_GRID_SUCCESS,
    FETCH_PRINTING_PART_DC_DETAILS_SECOND_GRID_REQUEST,
    CREATE_PRINTING_PART_DC_DETAILS2_REQUEST,
    CREATE_PRINTING_PART_DC_DETAILS2_SUCCESS,
    CREATE_PRINTING_PART_DC_DETAILS2_FAILURE,
    PRINTING_PART_PROGRAM_ID_REQUEST,
    PRINTING_PART_PROGRAM_ID_SUCCESS,
    PRINTING_PART_PROGRAM_ID_FALIURE,
    FETCH_PRINTING_DC_DETAILS_APPROVAL_STATUS_FAILURE,
    FETCH_PRINTING_DC_DETAILS_APPROVAL_STATUS_SUCCESS,
    FETCH_PRINTING_DC_DETAILS_APPROVAL_STATUS_REQUEST,
    FETCH_PRINTING_DC_STITCHED_PREVIOUS_LIST_SUCCESS,
    FETCH_PRINTING_DC_STITCHED_PREVIOUS_LIST_REQUEST,
    FETCH_PRINTING_DC_STITCHED_PREVIOUS_LIST_FAILURE,
    FETCH_IS_PART_PRINTING_DC_PREVIOUS_LIST_REQUEST,
    FETCH_IS_PART_PRINTING_DC_PREVIOUS_LIST_FAILURE,
    FETCH_IS_PART_PRINTING_DC_PREVIOUS_LIST_SUCCESS,
    CREATE_USER_FORM_PRINTING_DC_GENERATE_QTY,
    PRINTING_DC_WITH_BUNDLE_GET_SUCCESS,
    PRINTING_DC_WITH_BUNDLE_GET_REQUEST,
    PRINTING_DC_WITH_BUNDLE_GET_FAILURE,
    UPDATE_PRINTING_BUNDLE_FILTER_INITIAL,
    PRINTING_DC_WITH_BUNDLE_UPDATE_SELECTED_BUNDLE,
    PRINTING_DC_WITH_BUNDLE_POST_REQUEST,
    PRINTING_DC_WITH_BUNDLE_POST_FAILURE,
    PRINTING_DC_WITH_BUNDLE_POST_GET_SUCCESS,
    PRINTING_DC_WITH_BUNDLE_POST_GET_REQUEST,
    PRINTING_DC_WITH_BUNDLE_POST_GET_FAILURE,
    PRINTING_WITH_BUNDLE_RESET_DATA,
    PRINTING_OIL_ADAS_ALLOWED_QTY_GET_SUCCESS,
    PRINTING_OIL_ADAS_ALLOWED_QTY_GET_REQUEST,
    PRINTING_OIL_ADAS_ALLOWED_QTY_GET_FAILURE
} from './printingDCDetails.actionsType';

export const PRINTING_DC_DETAILS = 'printingDcDetails';

let initialState = {
    loading: false,
    printingDCDetailsById: [],
    printingDCDetails: [],
    printingDCDetailsDcNo: [],
    grnNoByPrintingDcNo: [],
    editPrintingQtyList: [],
    editPrintingSecondGridQtyList: [],
    editPrintingSecondGridData: [],
    printingDCDetailsProgram: [],
    printingBundleGetListFilter: [],
    userform: {
        fldRate: 0,
        fldQuantity: 0,
        fldGrossValue: 0,
        fldDiscountValue: 0,
        fldIGSTValue: 0,
        fldSGSTValue: 0,
        fldCGSTValue: 0,
        fldTaxableValue: 0,
        fldGSTValue: 0,
        fldSGSTPercentage: 0,
        fldCGSTPercentage: 0,
        fldIGSTPercentage: 0
    },
    selectedPrintingDCDetails: {},
    errorMessage: '',
    iperrorMessage: '',
    previousList: [],
    PartPrintingpreviousList: [],
    StitchedPreviousList: [],
    printingOilAdasAllowedQty: {}

};

export let printingDCDetailsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_PRINTING_DC_DETAILS_REQUEST:
        case FETCH_PRINTING_DC_DETAILS_PROGRAM_REQUEST:
        case FETCH_GRN_NO_BY_PRINTING_DC_NO_REQUEST:
        case FETCH_PRINTING_DC_DETAILS_DC_NO_REQUEST:
        case FETCH_PRINTING_DC_DETAILS_BY_ID_REQUEST:
        case CREATE_PRINTING_DC_DETAILS_REQUEST:
        case FETCH_SINGLE_PRINTING_DC_DETAILS_REQUEST:
        case UPDATE_PRINTING_DC_DETAILS_REQUEST:
        case DELETE_PRINTING_DC_DETAILS_REQUEST:
        case FETCH_PRINTING_DC_PREVIOUS_LIST_REQUEST:
        case FETCH_PRINTING_PART_DC_DETAILS_FIRST_GRID_REQUEST:
        case FETCH_PRINTING_PART_DC_DETAILS_SECOND_GRID_REQUEST:
        case CREATE_PRINTING_PART_DC_DETAILS2_REQUEST:
        case PRINTING_PART_PROGRAM_ID_REQUEST:
        case FETCH_PRINTING_DC_DETAILS_APPROVAL_STATUS_REQUEST:
        case FETCH_PRINTING_DC_STITCHED_PREVIOUS_LIST_REQUEST:
        case FETCH_IS_PART_PRINTING_DC_PREVIOUS_LIST_REQUEST:
        case PRINTING_DC_WITH_BUNDLE_GET_REQUEST:
        case PRINTING_DC_WITH_BUNDLE_POST_REQUEST:
        case PRINTING_DC_WITH_BUNDLE_POST_GET_REQUEST:
        case PRINTING_OIL_ADAS_ALLOWED_QTY_GET_REQUEST:
            return {
                ...state,
                loading: true
            };
        case PRINTING_OIL_ADAS_ALLOWED_QTY_GET_SUCCESS:
            return {
                ...state,
                printingOilAdasAllowedQty: updatePayload
            }
        case FETCH_PRINTING_DC_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                printingDCDetails: updatePayload
            };
        case FETCH_PRINTING_DC_DETAILS_PROGRAM_SUCCESS:
            return {
                ...state,
                loading: false,
                printingDCDetailsProgram: updatePayload
            };
        case FETCH_PRINTING_DC_DETAILS_APPROVAL_STATUS_SUCCESS:
            return {
                ...state,
                loading: false
            };
        case FETCH_PRINTING_PART_DC_DETAILS_FIRST_GRID_SUCCESS:
            return {
                ...state,
                loading: false,
                editPrintingQtyList: updatePayload?.Program
            };
        case FETCH_PRINTING_PART_DC_DETAILS_SECOND_GRID_SUCCESS:
            return {
                ...state,
                loading: false,
                editPrintingSecondGridQtyList: updatePayload?.PPD && updatePayload?.PPD.map((x) => ({ ...x, isCheck: false })) || [],
                editPrintingSecondGridData: updatePayload?.PPD && updatePayload?.PPD.map((x) => ({ ...x, isCheck: false })) || []
                //editPrintingSecondGridQtyList :  updatePayload?.PPD.map((x) => ({ ...x, isCheck: false }))
            };
        case FETCH_PRINTING_DC_DETAILS_BY_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                printingDCDetailsById: updatePayload
            };
        case FETCH_GRN_NO_BY_PRINTING_DC_NO_SUCCESS:
            return {
                ...state,
                loading: false,
                grnNoByPrintingDcNo: updatePayload?.Inward
            };
        case FETCH_PRINTING_DC_PREVIOUS_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                previousList: updatePayload?.Program
            };
        case CREATE_USER_FORM_PRINTING_DC_GENERATE_QTY:
            return {
                ...state,
                loading: false,
                previousList1: payload
            }
        case FETCH_IS_PART_PRINTING_DC_PREVIOUS_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                PartPrintingpreviousList: updatePayload?.Program
            };

        case FETCH_PRINTING_DC_STITCHED_PREVIOUS_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                StitchedPreviousList: updatePayload?.PPD
            };
        case CREATE_PRINTING_DC_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                },
                editPrintingQtyList: []
            };
        case CREATE_PRINTING_PART_DC_DETAILS2_SUCCESS:
            return {
                ...state,
                loading: false,

                editPrintingSecondGridQtyList: []
            };
        case PRINTING_PART_PROGRAM_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                fldFkProgramId: updatePayload.fldFKProgram
            };
        case CREATE_PRINTING_PART_DC_DETAILS2_SUCCESS:
            return {
                ...state,
                loading: false,

                editPrintingSecondGridQtyList: []
            };
        case FETCH_PRINTING_DC_DETAILS_DC_NO_SUCCESS:
            return {
                ...state,
                loading: false,
                printingDCDetailsDcNo: updatePayload?.PRPD
            };
        case FETCH_SINGLE_PRINTING_DC_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedPrintingDCDetails: updatePayload[0],
                userform: updatePayload[0]
            };
        case UPDATE_PRINTING_DC_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedPrintingDCDetails: {},
                userform: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                }
            };
        case DELETE_PRINTING_DC_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                },
                selectedPrintingDCDetails: {}
            };
        case PRINTING_DC_WITH_BUNDLE_GET_SUCCESS:
            return {
                ...state,
                printingBundleGetList: updatePayload?.Program?.map((x) => ({ ...x, FldIssuedBundleCount: x.FldBundleCount, isActive: false })),
                printingBundleGetListFilter: updatePayload?.Program?.map((x) => ({ ...x, FldIssuedBundleCount: x.FldBundleCount, isActive: false, FldBundleCount: x.FldPendingBundleCount }))
            }
        case UPDATE_PRINTING_BUNDLE_FILTER_INITIAL: {
            return {
                ...state,
                printingBundleGetListFilter: payload
            }
        }
        case PRINTING_DC_WITH_BUNDLE_UPDATE_SELECTED_BUNDLE:
            return {
                ...state,
                printingBundleGetList: payload

            }
        case PRINTING_WITH_BUNDLE_RESET_DATA:
            return {
                ...state,
                printingBundleGetList: [],
                printingBundleGetListFilter: [],
                printingOilAdasAllowedQty: {}

            }
        case PRINTING_DC_WITH_BUNDLE_POST_GET_SUCCESS:
            return {
                ...state,
                printingBundlePrevList: updatePayload.Program
            }
        case FETCH_PRINTING_DC_DETAILS_FAILURE:
        case FETCH_PRINTING_DC_DETAILS_PROGRAM_FAILURE:
        case FETCH_PRINTING_DC_DETAILS_DC_NO_FAILURE:
        case FETCH_GRN_NO_BY_PRINTING_DC_NO_FAILURE:
        case FETCH_SINGLE_PRINTING_DC_DETAILS_FAILURE:
        case CREATE_PRINTING_DC_DETAILS_FAILURE:
        case UPDATE_PRINTING_DC_DETAILS_FAILURE:
        case DELETE_PRINTING_DC_DETAILS_FAILURE:
        case FETCH_PRINTING_DC_PREVIOUS_LIST_FAILURE:
        case FETCH_PRINTING_PART_DC_DETAILS_FIRST_GRID_FAILURE:
        case FETCH_PRINTING_PART_DC_DETAILS_SECOND_GRID_FAILURE:
        case CREATE_PRINTING_PART_DC_DETAILS2_FAILURE:
        case PRINTING_PART_PROGRAM_ID_FALIURE:
        case FETCH_PRINTING_DC_DETAILS_APPROVAL_STATUS_FAILURE:
        case FETCH_PRINTING_DC_STITCHED_PREVIOUS_LIST_FAILURE:
        case FETCH_IS_PART_PRINTING_DC_PREVIOUS_LIST_FAILURE:
        case PRINTING_DC_WITH_BUNDLE_GET_FAILURE:
        case PRINTING_DC_WITH_BUNDLE_POST_FAILURE:
        case PRINTING_DC_WITH_BUNDLE_POST_GET_FAILURE:
        case PRINTING_OIL_ADAS_ALLOWED_QTY_GET_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_PRINTING_DC_DETAILS:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case CREATE_USER_FORM_PRINTING_PART_DC_EDIT_QTY:
            return {
                ...state,
                loading: false,
                editPrintingSecondGridQtyList: payload
            };
        case CREATE_USER_FORM_PRINTING_PART_DC_SECOND_GRID_EDIT_QTY:
            return {
                ...state,
                loading: false,
                editPrintingSecondGridData: payload
            };
        case RESET_PRINTING_PART_DC_EDIT_QTY_V2:
            return {
                ...state,
                loading: false,
                editPrintingSecondGridQtyList: []
            };
        case RESET_PRINTING_PART_DC_SECOND_GRIG_EDIT_QTY_V2:
            return {
                ...state,
                loading: false,
                editPrintingSecondGridQtyList: []
            };
        case PRINTING_DC_DETAILS_USERFORM_RESET:
            return {
                ...state,
                userform: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                },
                selectedPrintingDCDetails: {},
                editPrintingSecondGridQtyList: [],
                editPrintingSecondGridData: []
            };
        default:
            return state;
    }
};
